import { anyOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const isZendeskSunshineIntegration = objectOf({
  company_id: string,
  app_group_id: string,
  integration_id: string,
  subdomain: string,
  sunshine_app_id: string,
  key_id: string,
  key_secret: anyOf(string, () => true),
  webhook_secret: anyOf(string, () => true),
  custom_integration_id: anyOf(string, () => true),
  connected_at: anyOf(string, () => true),
});

// The GET endpoint returns {integration: {}} when the workspace has never connected.
// objectOf({}) accepts any object, so the unconnected branch checks emptiness explicitly
// to reject partially populated integrations.
const isEmptyObject = (value: unknown): value is Record<string, never> =>
  typeof value === "object" && value !== null && Object.keys(value).length === 0;

export const isGetAlloysZendeskSunshineAppGroupIdResult = objectOf({
  integration: anyOf(isZendeskSunshineIntegration, isEmptyObject),
});
